import { useCallback, useMemo } from 'react';

/** Company-level menus visible while demo user has no projects yet. */
export const DEMO_BOOTSTRAP_COMPANY_MENUS = new Set(['projects', 'settings', 'help']);

export const DEMO_BOOTSTRAP_CLIENTS_ROUTE = '/master-data/clients';

/**
 * Wrap MenuAccess helpers for demo bootstrap (Projects + Settings/Clients only).
 */
export function useProgressiveMenuAccess({
  isDemoProjectBootstrap,
  hasMenuAccess,
  hasMenuAccessOrChild,
}) {
  const showCompanyMenu = useCallback(
    (menuId) => {
      if (menuId === 'help') return true;
      if (!isDemoProjectBootstrap) return true;
      return DEMO_BOOTSTRAP_COMPANY_MENUS.has(menuId);
    },
    [isDemoProjectBootstrap],
  );

  const navHasMenuAccess = useCallback(
    (route) => {
      if (!isDemoProjectBootstrap) return hasMenuAccess(route);
      const base = String(route || '').split('?')[0];
      if (base === DEMO_BOOTSTRAP_CLIENTS_ROUTE) return true;
      return hasMenuAccess(route);
    },
    [isDemoProjectBootstrap, hasMenuAccess],
  );

  const navHasMenuAccessOrChild = useCallback(
    (parent, children = []) => {
      if (!isDemoProjectBootstrap) return hasMenuAccessOrChild(parent, children);
      if (parent === '/settings') return true;
      return hasMenuAccessOrChild(parent, children);
    },
    [isDemoProjectBootstrap, hasMenuAccessOrChild],
  );

  return useMemo(
    () => ({
      showCompanyMenu,
      hasMenuAccess: navHasMenuAccess,
      hasMenuAccessOrChild: navHasMenuAccessOrChild,
    }),
    [showCompanyMenu, navHasMenuAccess, navHasMenuAccessOrChild],
  );
}
